// extracted by mini-css-extract-plugin
export var active = "_90-b";
export var activeIndicator = "_90-6";
export var animate = "_90-a";
export var disabled = "_90-c";
export var flat = "_90-1";
export var fullWidth = "_90-3";
export var lg = "_90-9";
export var md = "_90-8";
export var redoButtonTabGroup = "_90-0";
export var sm = "_90-7";
export var tabButton = "_90-4";
export var tabButtonsContainer = "_90-2";
export var xs = "_90-5";